import { render, staticRenderFns } from "./AddressFilter.vue?vue&type=template&id=bbf1adb2&"
import script from "./AddressFilter.vue?vue&type=script&lang=js&"
export * from "./AddressFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports